module.exports = __webpack_public_path__ + "img/robot.8ec87fad.png";